import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-79d11854")
const _hoisted_1 = { class: "farming-record-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*"),
  /*#__PURE__*/_createTextVNode("干活时间")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "亩", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "人工", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "text" }, "1人1天记1个人工", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "text" }, " 例如：1人干了两天，记2个人工；3人干了1.5天，记4.5个人工； ", -1)
const _hoisted_7 = { class: "cup-line" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*"),
  /*#__PURE__*/_createTextVNode("照片")
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "text" }, "最多9张", -1)
const _hoisted_10 = { class: "cup-line" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "视频", -1)
const _hoisted_12 = {
  key: 1,
  class: "v-pos"
}
const _hoisted_13 = ["src", "poster"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "text" }, "可上传1个视频", -1)
const _hoisted_15 = { class: "cup-line" }
const _hoisted_16 = { class: "pop-btn" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" 提交 ")
const _hoisted_18 = ["src"]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_divider = _resolveComponent("van-divider")!
  const _component_van_uploader = _resolveComponent("van-uploader")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_form = _resolveComponent("van-form")!
  const _component_van_datetime_picker = _resolveComponent("van-datetime-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_form, { onSubmit: _ctx.onSubmit }, {
      default: _withCtx(() => [
        _createVNode(_component_van_cell_group, { border: true }, {
          default: _withCtx(() => [
            _createVNode(_component_van_field, {
              modelValue: _ctx.farmingTypeName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.farmingTypeName = $event)),
              readonly: "",
              label: "农事类型",
              placeholder: "点击选择类型"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_van_field, {
              modelValue: _ctx.farmingName,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.farmingName = $event)),
              readonly: "",
              label: "农事名称",
              placeholder: "请输入名称"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_van_field, {
              modelValue: _ctx.date,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.date = $event)),
              name: "date",
              readonly: "",
              class: "date-s",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showDateDialog = true)),
              placeholder: "点击选择日期",
              rules: [{ required: true, message: '干活日期必选' }]
            }, {
              label: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_van_field, {
              modelValue: _ctx.area,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.area = $event)),
              type: "number",
              label: "完成面积"
            }, {
              "right-icon": _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_van_field, {
              border: false,
              modelValue: _ctx.person,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.person = $event)),
              type: "number",
              label: "人工投入"
            }, {
              "right-icon": _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _hoisted_5,
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_van_divider)
            ]),
            _createVNode(_component_van_field, {
              name: "images",
              border: false,
              rules: [{ required: true, message: '请上传图片' }]
            }, {
              label: _withCtx(() => [
                _hoisted_8
              ]),
              input: _withCtx(() => [
                _createVNode(_component_van_uploader, {
                  "max-count": 9,
                  multiple: "",
                  "before-delete": _ctx.delBefore,
                  "after-read": _ctx.imageUploadAfter,
                  accept: "image/png,image/jpg,image/jpeg",
                  modelValue: _ctx.imageList,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.imageList = $event))
                }, null, 8, ["before-delete", "after-read", "modelValue"])
              ]),
              _: 1
            }),
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_van_divider)
            ]),
            _createVNode(_component_van_field, {
              name: "videos",
              "max-count": 1,
              border: false
            }, {
              label: _withCtx(() => [
                _hoisted_11
              ]),
              input: _withCtx(() => [
                (!_ctx.uploadSuccessVideo)
                  ? (_openBlock(), _createBlock(_component_van_uploader, {
                      key: 0,
                      "max-count": 1,
                      accept: "video/*",
                      "after-read": _ctx.afterUploadVideo,
                      modelValue: _ctx.videoList,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.videoList = $event)),
                      deletable: false
                    }, null, 8, ["after-read", "modelValue"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("video", {
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showVideos = true)),
                        src: _ctx.uploadSuccessVideo,
                        width: "88",
                        height: "88",
                        poster: _ctx.uploadSuccessVideo + '?vframe/jpg/offset/1/w/88/h/88'
                      }, null, 8, _hoisted_13),
                      _createVNode(_component_van_icon, {
                        class: "del",
                        onClick: _ctx.delVideoBefore,
                        name: "close"
                      }, null, 8, ["onClick"])
                    ]))
              ]),
              _: 1
            }),
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_van_divider)
            ]),
            _createVNode(_component_van_field, {
              type: "textarea",
              row: 3,
              modelValue: _ctx.other,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.other = $event)),
              label: "其他事项",
              placeholder: "请输入"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_van_button, {
            round: "",
            block: "",
            type: "primary",
            disabled: _ctx.isUpload,
            "native-type": "submit"
          }, {
            default: _withCtx(() => [
              _hoisted_17
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      _: 1
    }, 8, ["onSubmit"]),
    _createVNode(_component_van_popup, {
      show: _ctx.showDateDialog,
      "onUpdate:show": _cache[12] || (_cache[12] = ($event: any) => (_ctx.showDateDialog = $event)),
      round: "",
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_datetime_picker, {
          modelValue: _ctx.currentDate,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.currentDate = $event)),
          type: "date",
          title: "干活时间",
          "max-date": _ctx.maxDate,
          "min-date": _ctx.minDate,
          onCancel: _cache[11] || (_cache[11] = ($event: any) => (_ctx.showDateDialog = false)),
          onConfirm: _ctx.dateConfirm
        }, null, 8, ["modelValue", "max-date", "min-date", "onConfirm"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_popup, {
      show: _ctx.showVideos,
      "onUpdate:show": _cache[13] || (_cache[13] = ($event: any) => (_ctx.showVideos = $event)),
      closeable: "",
      style: {"width":"85%","height":"85%","background":"none"}
    }, {
      default: _withCtx(() => [
        _createElementVNode("video", {
          controls: "",
          src: _ctx.uploadSuccessVideo,
          style: {"width":"100%","height":"100%"}
        }, null, 8, _hoisted_18)
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}